import { useState } from 'react';
import gql from 'not-graphql-tag';
import { useQuery } from '@apollo/react-hooks';
import {
  SearchServiceAddress,
  SearchServiceAddressRequest,
  SearchServiceAddressResponse,
} from '../../__generated__/pge-types';

export const SEARCH_SERVICE_ADDRESS_QUERY = gql`
  query searchServiceAddress($payload: SearchServiceAddressRequest) {
    searchServiceAddress(payload: $payload) {
      addresses {
        addressLine1
        city
        postal
        premiseIds
      }
    }
  }
`;

interface Request {
  payload: SearchServiceAddressRequest;
}
interface Response {
  searchServiceAddress: SearchServiceAddressResponse;
}

export const useServiceAddressQuery = () => {
  const [searchString, setSearchString] = useState<string>();
  const { loading, error, data } = useQuery<Response, Request>(
    SEARCH_SERVICE_ADDRESS_QUERY,
    {
      variables: { payload: { match: searchString } },
      fetchPolicy: 'network-only',
    },
  );

  const filterData = data?.searchServiceAddress?.addresses
    ?.filter((item: any) =>
      item?.addressLine1.toLowerCase()?.includes(searchString?.toLowerCase()),
    )
    .sort((a: any, b: any) =>
      (a as SearchServiceAddress).addressLine1.localeCompare(
        (b as SearchServiceAddress).addressLine1,
      ),
    );

  const dataResult = {
    searchServiceAddress: {
      addresses: filterData,
    },
  };

  return {
    searchString,
    setSearchString,
    loading,
    error,
    data,
    filterData: dataResult,
  };
};
